// extracted by css-extract-rspack-plugin
export default {"BackToRepositorySelectionButton":"AlertPicker-module__BackToRepositorySelectionButton__ivf2R","alertNumberText":"AlertPicker-module__alertNumberText__BXiAl"};